<!-- 由 suu 创建于 2022-01-07 星期五 -->
<template>
  <div class="ArchiveItem">
    <!-- 头部 -->
    <div class="ai-header" :class="[headerClass]">
      <div class="h-top">
        <div class="t-name">{{ info.name }}</div>
        <div class="t-btn user-btn">{{ stateObj[info.state] }}</div>
      </div>
      <div class="h-bot">
        <div class="h-date">
          {{ info.start.replace(/-/g, '.') }} -
          {{ info.end.replace(/-/g, '.') }}
        </div>
        <div class="h-cur" v-if="info.state == 1"> 第{{ info.curDay }}天 </div>
      </div>
    </div>
    <!-- 角色 -->
    <div class="ar-person">
      <div class="p-item">
        <div class="p-title">营长：</div>
        <div class="p-cent">{{ info.leader }}</div>
      </div>
      <div class="p-item">
        <div class="p-title">点评老师：</div>
        <div class="p-cent" v-for="(item, index) in info.team" :key="index">
          {{ `${item}${index != info.team.length - 1 ? '、' : ''}` }}
        </div>
      </div>
    </div>
    <div class="ar-line"></div>
    <!-- 数据 -->
    <div class="ar-title">数据总览</div>
    <item-datas :list="info.datas"></item-datas>
    <template v-if="showMore">
      <!-- 每日餐卡监测 -->
      <div class="ar-title">每日餐卡监测</div>
      <item-meal
        :info="mealInfo"
        :starDay="info.start"
        :endDay="info.end"
        :initDay="currentDate"
        @date-change="handelDateChange"
      ></item-meal>
      <!-- 体测打卡（单位/人） -->
      <div class="ar-title">体测打卡（单位/人）</div>
      <item-test :list="testInfo"></item-test>
    </template>
    <!-- 底部按钮 -->
    <div class="ar-footer-btn user-btn" @click="handelGetMore(0)">
      {{ showMore ? '收起' : '展开'
      }}<van-icon :name="`arrow-${showMore ? 'up' : 'down'}`" />
    </div>
  </div>
</template>

<script>
import ItemDatas from './ItemDatas.vue'
import ItemMeal from './ItemMeal.vue'
import ItemTest from './ItemTest.vue'
import DATE from '@/common/date.js'
export default {
  name: 'ArchiveItem',

  components: { ItemDatas, ItemMeal, ItemTest },

  props: {
    info: {
      type: Object,
      require: true
    }
  },

  data() {
    return {
      mealInfo: null,
      testInfo: null,
      dayInfo: {},
      currentDate: new Date(),
      showMore: false,
      stateObj: {
        0: '未开始',
        1: '进行中',
        2: '已结束'
      }
    }
  },

  computed: {
    curDateText() {
      return DATE.formatDate(this.currentDate, '-')
    },
    headerClass() {
      return 'ai-header-' + this.info.state
    }
  },

  watch: {},

  created() {
    this.currentDate =
      this.currentDate > new Date(this.info.end.replace(/-/g, '/'))
        ? new Date(this.info.end.replace(/-/g, '/'))
        : this.currentDate
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 每日餐卡 日期改变
     */
    handelDateChange(date) {
      this.currentDate = date
      this.handelGetMore(1)
    },
    /**
     * 获取更多
     */
    handelGetMore(flag = 0) {
      if (this.dayInfo[this.curDateText]) {
        this.showMore = flag ? this.showMore : !this.showMore
        this.mealInfo = this.dayInfo[this.curDateText].meal
        this.testInfo = this.dayInfo[this.curDateText].test
      } else {
        this.$toast.loading('加载中··')
        const param = {
          pid: this.info.pid,
          day: this.curDateText
        }
        this.$http
          .getApp('/member/AppCampCoach/getItemByDay', param)
          .then((res) => {
            this.$toast.clear()
            if (res.data.code == 200) {
              this.dayInfo[this.curDateText] = res.data.data
              this.mealInfo = this.dayInfo[this.curDateText].meal
              this.testInfo = this.dayInfo[this.curDateText].test
              this.showMore = true
            } else {
              this.$notify({ type: 'danger', message: res.data.msg })
            }
          })
          .catch((err) => {
            this.$toast.clear()
            this.$notify({ type: 'danger', message: '网络错误' })
          })
      }
    },
    /**
     * 获取头部背景颜色
     */
    _headerBackColor(state) {
      switch (state) {
        case 0:
          return '#ccc'
        case 1:
          return '#ccc'
        case 0:
          return '#ccc'

        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.ArchiveItem {
  width: 343px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 10px;
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 20px;
  .ai-header {
    width: 343px;
    box-sizing: border-box;
    background-color: #ccc;
    padding: 10px 16px;
    .h-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .t-name {
        flex: 1;
        font-size: 18px;
        font-weight: 500;
        color: #ffffff;
        margin-right: 20px;
      }
      .t-btn {
        font-size: 10px;
        font-weight: 500;
        color: #000000;
        padding: 3px 8px;
        background: #ffffff;
        border-radius: 4px;
      }
    }
    .h-bot {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 4px;
      .h-date {
      }
      .h-cur {
      }
    }
  }
  .ai-header-0 {
    background: #838aae;
  }
  .ai-header-1 {
    background: linear-gradient(180deg, #f96060 0%, #f04646 100%);
  }
  .ai-header-2 {
    background: #ccc;
  }
  .ar-person {
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    font-size: 12px;
    line-height: 20px;
    .p-item {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      word-break: break-all;
      align-items: center;
      .p-title {
        color: #808080;
      }
      .p-cent {
        color: #000000;
        font-weight: 500;
      }
    }
  }
  .ar-line {
    width: 100%;
    box-sizing: border-box;
    height: 1px;
    background-color: #f1f1f1;
    margin-top: 12px;
  }
  .ar-title {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
  }
  .ar-footer-btn {
    width: 311px;
    height: 37px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #f1f1f1;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 14px;
    font-size: 15px;
    // font-weight: 450;
    i {
      font-size: 15px;
      color: #ccc;
      margin-left: 5px;
      font-weight: 600;
    }
  }
}
</style>
